import AnalyticsManager from '../../../AnalyticsManager';

const projectConfig = require('../../../project.config.json');

class SplashTrackingManager {
  constructor() {
    this.commonData = {
      journey_type: 'Splash',
    };
  }

  trackEvent(event, additionalData = {}) {
    AnalyticsManager.trackEvent(event, {
      ...this.commonData,
      ...additionalData,
    });
  }

  trackView(additionalData = {}) {
    const nonOverridableData = {
      component_name: AnalyticsManager.getComponentName(projectConfig.name),
      component_version: AnalyticsManager.getComponentVersion(projectConfig.version),
      component_owner: AnalyticsManager.getComponentOwner(),
    };
    AnalyticsManager.trackView('page_view', {
      ...this.commonData,
      ...additionalData,
      ...nonOverridableData,
    });
  }
}

export default SplashTrackingManager;
